// extracted by mini-css-extract-plugin
export var layoutContainer = "_4v-0";
export var layoutContainerNoRounding = "_4v-6";
export var layoutContainerOpen = "_4v-5";
export var layoutContainerResizing = "_4v-1";
export var mainContent = "_4v-2";
export var resizeDivider = "_4v-3";
export var slidePanel = "_4v-4";